import React from "react";
import { Button, Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";

const ActionButton = ({
  icon: Icon,
  tooltip,
  onClick,
  variant = "circle", // Default: Circular button
  disabled = false, // Default: Not disabled
}) => {
  if (variant === "dropdown") {
    return (
      <Dropdown.Item
        onClick={!disabled ? onClick : null}
        disabled={disabled}
        className="no-highlight"
      >
        {Icon && <Icon className="me-2" />} {tooltip}
      </Dropdown.Item>
    );
  }

  return (
    <OverlayTrigger placement="bottom" overlay={<Tooltip>{tooltip}</Tooltip>}>
      <span className="d-inline-block">
        <Button
          variant="light"
          className="bg-gray rounded-circle btn-centered-icon"
          onClick={onClick}
          disabled={disabled}
        >
          {Icon && <Icon className="icon-dark" />}
        </Button>
      </span>
    </OverlayTrigger>
  );
};

export default ActionButton;
